export default class View {
  constructor(model) {
    if (model) {
      // eslint-disable-next-line no-restricted-syntax
      for (const prop of Object.keys(model)) {
        this[prop] = model[prop];
      }
    }
  }
}
